import React, { useState } from "react";
import { useForm, ValidationError } from "@formspree/react";
import Navbar2 from "../../components/Navbar2/Navbar2";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import vImg from "../../images/volunteer.webp";

const VolunteerPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [state, handleSubmit] = useForm("xpwzllaa");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  if (state.succeeded) {
    return (
      <div className="volunteer-page">
        <Navbar2 />
        <PageTitle pageTitle={"Volunteer"} pagesub={"Volunteer"} />
        <div className="volunteer-area">
          <div className="volunteer-wrap">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div className="volunteer-item">
                    <div className="volunteer-img-wrap">
                      <div className="volunter-img">
                        <img src={vImg} alt="" />
                      </div>
                    </div>
                  </div>
                  <div className="volunteer-contact">
                    <div className="volunteer-contact-form">
                      <h2>Thank you for your message!</h2>
                      <p>
                        We appreciate your interest in volunteering with us. Our
                        team will get back to you shortly.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <Scrollbar />
      </div>
    );
  }

  return (
    <div className="volunteer-page">
      <Navbar2 />
      <PageTitle pageTitle={"Volunteer"} pagesub={"Volunteer"} />
      <div className="volunteer-area">
        <div className="volunteer-wrap">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="volunteer-item">
                  <div className="volunteer-img-wrap">
                    <div className="volunter-img">
                      <img src={vImg} alt="" />
                    </div>
                  </div>
                </div>
                <div className="volunteer-contact">
                  <div className="volunteer-contact-form">
                    <h2>Become a Volunteer</h2>
                    <form
                      onSubmit={handleSubmit}
                      className="contact-validation-active"
                    >
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-12 form-group">
                          <div className="form-field">
                            <input
                              value={formData.name}
                              type="text"
                              name="name"
                              onChange={handleChange}
                              placeholder="Your Name"
                              required
                            />
                            <ValidationError
                              prefix="Name"
                              field="name"
                              errors={state.errors}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-12 form-group">
                          <div className="form-field">
                            <input
                              value={formData.email}
                              type="email"
                              name="email"
                              onChange={handleChange}
                              placeholder="Your Email"
                              required
                            />
                            <ValidationError
                              prefix="Email"
                              field="email"
                              errors={state.errors}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-12 form-group">
                          <div className="form-field">
                            <input
                              value={formData.phone}
                              type="tel"
                              name="phone"
                              onChange={handleChange}
                              placeholder="Your Phone"
                              required
                            />
                            <ValidationError
                              prefix="Phone"
                              field="phone"
                              errors={state.errors}
                            />
                          </div>
                        </div>
                        <div className="col-lg-12 col-12 form-group">
                          <textarea
                            value={formData.message}
                            name="message"
                            onChange={handleChange}
                            placeholder="Message"
                            required
                          ></textarea>
                          <ValidationError
                            prefix="Message"
                            field="message"
                            errors={state.errors}
                          />
                        </div>
                        <div className="submit-area col-lg-12 col-12">
                          <button
                            type="submit"
                            className="theme-btn submit-btn"
                            disabled={state.submitting}
                          >
                            Send Message
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <Scrollbar />
    </div>
  );
};

export default VolunteerPage;
